import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';
import useAppUser from 'hooks/useAppUser';
import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import { HOSTFULLY_ASSIST_PATH } from './HostfullyAssist.constants';

const useHostfullyAssist = () => {
  const { isEmployeeManager } = useAppUser();
  const { data, isInitialLoading: isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: IntegrationEnum.HOSTFULLYASSIST,
      enabled: isEmployeeManager,
    });

  const { integration, agencySettings } = data ?? {};

  // BE also checks for the enabled feature flag and any other requirement, thus
  // the FE only needs to check the integration status.
  const isAssistEligible = Boolean(
    integration &&
      agencySettings &&
      agencySettings.status !== IntegrationStatus.NOT_SUPPORTED,
  );

  const isAssistActive = agencySettings?.status === IntegrationStatus.ACTIVE;

  const hasEnrolledBefore = agencySettings?.hasEnrolledBefore ?? false;

  const isCurrentlyOrPastEnrolled = isAssistActive || hasEnrolledBefore;

  const getAssistMenuEntryPath = () => {
    if (isAssistActive) {
      return '/ai-hub';
    }

    if (hasEnrolledBefore) {
      return `/integrations/details/${IntegrationEnum.HOSTFULLYASSIST}`;
    }

    return HOSTFULLY_ASSIST_PATH;
  };

  return {
    isAssistEligible,
    isAssistActive,
    isLoading,
    hasEnrolledBefore,
    isCurrentlyOrPastEnrolled,
    assistMenuEntryPath: getAssistMenuEntryPath(),
  };
};

export default useHostfullyAssist;
